export default {
	//當前所在頁面 pcb/smt/smd/fpc/rfpc/sales
	stay:"",
	//關聯訂單 爲空則無關聯，與上面stay結合
	relation:"",		
	//物流，國家，等參數
	aside_param:{},
	//pcb參數
	pcb_params:{},
	//pcb高端板材參數
	pcb_high_params:{},
	//fpc需要提交的參數
	fpc_params: {},
	//rfpc_params
	rfpc_params: {},	
	//pcb需要提交的參數
	//smt需要提交的參數
	smt_params:{},
	//smd需要提交的參數
	smd_params:{},
	//各个板材计价是否满足最低条件/或者是否可计价
	canQuote:{},
	//用於保存上傳數據
	pcbSize:{},
	//隐藏状态的pcb参数
	pcb_hideparams:{},
	//隐藏smt的状态
	smt_hideparams:{},
	//面積
	area:0,
	//計價后的數據
	valuation:null,
	//pcbFirstTips
	pcbFirstTips:"",
	hasFirstTips:"",
	//物流數據
	expressList: null,
	//計價請求遮罩
	quoteLoading: false,
	//是否点击计价按钮
	isCalcBtn:false,
	//暂存的 计价参数
	ajaxQuoteParams:null,
	smtQuoteOn:0,
	// 是否是smt Free Assembly for 5 pieces 活动
	isSmtActivity:false,
	// 是否正在计价中
	isValuationing: false,
	// 文件解析ID
	analyseId: null,
	// 阶梯价格
	stepPrice: [],
	// 是否阶梯价格点击改变数量
	isStepClick: false,
	// 加载阶梯价格
	isLoadingStepPrice: false,
	// 计价参数检查
	paramsCheck:{},
	// 系统自动计价
	isSystemQuote: false,
	analyzeSuccess: 0,
	gerberFileIsChange: 0,
	engineerEmails: [],
	// 自定义变量的值
	customValue:{},
	// 使用自定的字段
	customField:{},
	customErr:{}
}